export default "__VITE_ASSET__eHL0XHd8__"